import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {ActionResult} from "../model";

const AppUpdatePage = () => {


    return (
        <div className={'container'} style={{paddingTop: 20}}>
            <Row>
                <Col sm={12}>
                    <div className={'card'}>
                        <div className={'card-body'}>
                            <h6 className="text-center  text-lg-center lr ">최신버전으로 앱 업데이트 후 이 설문 쿠폰을 작성할 수 있습니다. <br/>업데이트 후 다시 진행하여 주세요.</h6>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}
export default AppUpdatePage;
